import './component.scss'

import './images/rank_1.svg'
import './images/rank_2.svg'
import './images/rank_3.svg'

import { Application, Controller } from 'stimulus'

const app = Application.start()

app.register(
  'company-sp-sticky-header',
  class extends Controller {
    static targets = ['header', 'trigger']

    connect () {
      this.observer = null

      this.handleResize = this.setupObservers.bind(this)
      window.addEventListener('resize', this.handleResize)

      this.setupObservers()
    }

    disconnect () {
      if (this.observer) {
        this.observer.disconnect()
      }
      window.removeEventListener('resize', this.handleResize)
    }

    setupObservers () {
      const targetToObserve = this.triggerTarget

      if (targetToObserve) {
        const options = { root: null, rootMargin: '0px', threshold: 0 }
        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), options)
        this.observer.observe(targetToObserve)
      }
    }

    /**
     * 要素が画面内外に移動したときに呼び出されるコールバック
     * @param {IntersectionObserverEntry[]} entries
     */
    handleIntersection (entries) {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          this.showHeader()
        } else {
          this.hideHeader()
        }
      })
    }

    showHeader () {
      this.headerTarget.classList.add('company-sp-sticky-header--visible')
    }

    hideHeader () {
      this.headerTarget.classList.remove('company-sp-sticky-header--visible')
    }
  }
)
